import type { SelectProps } from "antd";
import type { BaseOptionType, DefaultOptionType } from "antd/es/select";
import classNames from "~utils/classNames";
import { GlobalStyles, StyledDimBackground, StyledLoader, StyledOptionsWrapper, StyledSelect } from "./CustomSelect.styles";

type OnChangeHandlerType = (
  value: unknown,
  option: BaseOptionType | DefaultOptionType | (BaseOptionType | DefaultOptionType)[] | undefined,
) => void;

export type CustomSelectProps<TOptions extends unknown[]> = Omit<SelectProps, "onChange"> & {
  options?: TOptions;
  onChange?: OnChangeHandlerType;
};

const CustomSelect = <TOptions extends unknown[]>({
  popupClassName,
  popupRender,
  onChange,
  loading,
  ...props
}: CustomSelectProps<TOptions>) => (
  <>
    <GlobalStyles />
    <StyledSelect
      {...props}
      loading={loading}
      $loading={loading}
      popupClassName={classNames(popupClassName, "select-dropdown-custom")}
      popupMatchSelectWidth={false}
      onChange={onChange as OnChangeHandlerType}
      popupRender={(menu) => (
        <>
          {loading && (
            <>
              <StyledDimBackground />
              <StyledLoader />
            </>
          )}
          <StyledOptionsWrapper>{popupRender?.(menu) ?? menu}</StyledOptionsWrapper>
        </>
      )}
    />
  </>
);

export default CustomSelect;
